/* eslint-disable react/require-default-props */
import {Outlet, useSearchParams} from "react-router-dom"
import Container from '@mui/material/Container';
import { URL_PARAMS, DISP_MODE } from '../../../constants/constants'
import WorkFuncTab from '../components/WorkFuncTab';
import {DataStoreContextProvider} from "../contexts/WorkContext";

export default function WorkLayout() {
  const [searchParams] = useSearchParams();
  const isPopupMode = !!(searchParams.get(URL_PARAMS.DISP_MODE) && searchParams.get(URL_PARAMS.DISP_MODE) === DISP_MODE.POPUP);
  return (
    <DataStoreContextProvider>
      { !isPopupMode &&
        <WorkFuncTab />
      }
      <Container sx={{
        mx:0, pb:3, pt:0, width:"100%", backgroundColor: 'white', maxWidth:"unset!important",
        ...(isPopupMode ? {p : "0 !important"} : {}) }}>
        <Container sx={{mx:0, pb:3, pt:1, width:"100%", backgroundColor: '#F6F7F8', maxWidth:"unset!important"}}>
          <Outlet />
        </Container>
      </Container>
    </DataStoreContextProvider>
  )
}
